import makeStyles from '@mui/styles/makeStyles';
import {isMatchActive, isOneToMany, isOneToOne, trackerStatus} from "business/matching";
import {isMentor} from "business/role";
import ClubMemberRuleDisplay from "components/Matching/ClubMemberRuleDisplay";
import MatchSummaries from "components/Matching/MatchSummaries";
import MenteeUnavailableWindow from "components/MenteeUnavailableWindow";
import MentorUnavailableWindow from "components/MentorUnavailableWindow";
import {filter, get} from 'lodash';
import React, {useEffect, useState} from "react";

const useStyles = makeStyles({
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
});

const PotentialMatches = ({matches, role, expiryHours, onUpdateMatch, groupInfo, userMatchType, submitMatchesResponse}) => {
  const classes = useStyles();

  const interestedTrackerCount = filter(filter(matches, isMatchActive),
    match => get(match, 'interestStatus', false) === trackerStatus.INTERESTED).length;

  const [openMenteeUnavailableWindow, setOpenMenteeUnavailableWindow] = useState(false);
  const [openMentorUnavailableWindow, setOpenMentorUnavailableWindow] = useState(false);

  useEffect(() => {
    setOpenMenteeUnavailableWindow(submitMatchesResponse === 'MENTEE_UNAVAILABLE');
    setOpenMentorUnavailableWindow(submitMatchesResponse === 'MENTOR_UNAVAILABLE');
  }, [submitMatchesResponse]);

  return (
    <div className={classes.column}>
      {!isOneToOne(userMatchType) && isMentor(role) &&
      <ClubMemberRuleDisplay groupInfo={groupInfo} interesetedTrackerCount={interestedTrackerCount}/>}

      <MatchSummaries
        matches={matches}
        role={role}
        expiryHours={expiryHours}
        userMatchType={userMatchType}
        onUpdateMatch={onUpdateMatch}
        showCriteria={isMentor(role) && isOneToMany(userMatchType)}/>

      <MenteeUnavailableWindow open={openMenteeUnavailableWindow} handleClose={() => setOpenMenteeUnavailableWindow(false)}/>
      <MentorUnavailableWindow open={openMentorUnavailableWindow} handleClose={() => setOpenMentorUnavailableWindow(false)}/>
    </div>
  )
};

export default PotentialMatches;
